module.exports = __webpack_public_path__ + "img/user-avatar.a54b8f26.png";